<template>
<!-- 视力报告-学生详情页面 -->
    <div class="student_details">
        <div class="details_content">
            <div class="header" >
                <div>{{ list.name }}</div>
                <div>所在学校：{{school }}</div>
                <div>所在班级：{{ list.class }}</div>
                <div>学籍号：{{ list.studentID }}</div>
                <div>设备号：{{ list.equipmentID }}</div>
                <div>手机号：{{ list.phone }}</div>
                <div>总时长：{{ list.totalDuration }}分钟</div>
            </div>

            <div class="container">
                <van-row class="list_header" type="flex" justify="center" align="center">
                    <van-col span="12">使用结束时间</van-col>
                    <van-col span="6">使用时长/min</van-col>
                <!--    <van-col span="6">压力值</van-col>-->
                </van-row>

                <van-row v-for="i in dataList" :key="i.index" class="list_content" type="flex" justify="center" align="center">
                    <van-col span="12">{{i.endTime}}</van-col>
                    <van-col span="6">{{i.usetTime}}</van-col>
                   <!-- <van-col span="6">{{i.pressure}}</van-col>-->
                </van-row>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Row, Col } from 'vant';

Vue.use(Row).use(Col);
export default {
    props: {

    },
    data() {
        return {
            list: {
                name: '',
                class: '',
                studentID: '',
                equipmentID: '',
                phone: '',
                totalDuration: 0
            },
            school: '',
            dataList: []

        };
    },
    computed: {

    },
    created() {
        this.get()
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        get() {
            this.axios.get('/weixin/student/getStudent', {
                params: {
               //     gradeName: this.$route.params.gradeName,
                    ft: this.$route.params.ft,
                    et: this.$route.params.et,
                  //  className: this.$route.params.className,
                    statusid: this.$route.params.statusid
                }
            })
            .then(res=>{
                this.list.name = res.data.listmap[0].sName
                this.list.class = this.$route.params.className
                this.list.studentID = res.data.listmap[0].statusid
                this.list.equipmentID = res.data.listmap[0].instrumentid
                this.list.phone = res.data.listmap[0].sphone
                this.school = res.data.listmap[0].choolName
                this.dataList = res.data.listmap
                const arr = []
                this.dataList.map(item=>{
                    return arr.push(item.usetTime)
                })
                function getSum(total, num) {
                    return total + num;
                }
                this.list.totalDuration = arr.reduce(getSum)
            })
        }
    },
    components: {

    },
};
</script>

<style scoped>
.student_details {
    padding: 28px;
}

.details_content {
    background: #fff;
    border-radius: 20px;
}

.header {
    padding: 28px;
}

.header {
    font-size: 32px;
    line-height: 60px;
}

.header div:first-of-type{
    font-size: 36px;
    margin: 10px 0 20px;
}

.container {
    font-size: 32px;
    text-align: center;
}

.list_header {
    background: #3f8ed4;
    color: #fff;
    height: 78px;
    line-height: 78px;
}

.list_content {
    background: none;
    height: 78px;
    line-height: 78px;
    border-bottom: 1px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/views/second/StudentDetails.vue